const KEY = 'redeem_wizard';

export function saveRedeemState(state) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(state));
  } catch (_) { /* storage lleno / bloqueado: no-op */ }
}

export function loadRedeemState() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

export function clearRedeemState() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (_) { /* no-op */ }
}
